import { Container } from "react-bootstrap";
import CustButton from "../CustButton";

const Testimonials = ({ data }) => {

  const { client_name, client_role, profile_image, message } = data;

  return (
    <>
      <div className="bg-testimonial w-100 p-0 m-0">
        <Container className="d-flex justify-content-center">
          <div className="col-10 d-flex flex-column gap-4 py-5 m-0">
            <h1 className="fs-3 fw-semibold">Testimonials</h1>
            <p style={{ fontSize: "48px"}}>
              “{message}”
            </p>
            <div className="d-flex col gap-3 p-0 h-auto">
              <div className="rounded-circle overflow-hidden testimonial-profile">
                <img
                  src={profile_image}
                  className="w-100"
                  alt="iconProfile"
                />
              </div>
              <div className="d-flex flex-column justify-content-center gap-0 p-0 m-0">
                <p className="default-box fs-4">{client_name}</p>
                <p className="default-box fs-5 text-color-abu fw-semibold">
                  {client_role}
                </p>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div className="w-100 p-0 m-0">
        <Container className="d-flex justify-content-center">
          <div
            className="col-10 d-flex justify-content-between align-items-center m-0"
            style={{
              padding: "80px 0px",
            }}
          >
            <h1 className="fw-bold w-50" style={{fontSize: "44px"}}>Ready to start project with us?</h1>
            <CustButton text={"Let's collaborate"} path={"/"} />
          </div>
        </Container>
      </div>
    </>
  );
};

export default Testimonials;
